import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_INGREDIENT_KEYWORDS } from '../action-types'

const cleanupCommonFetchIngredientKeywords = createAction(
  COMMON_FETCH_INGREDIENT_KEYWORDS.CLEANUP,
)
export default cleanupCommonFetchIngredientKeywords
